const FADE_END_MARGIN = 8;

document.addEventListener("alpine:init", () => {
    Alpine.data("LocationCardFade", () => ({
        showFade: false,

        init() {
            this.$nextTick(() => this.bindFade());
        },

        bindFade() {
            const body = this.$refs.body;
            if (!body) {
                return;
            }

            this.syncFade();
            this._resize = new ResizeObserver(() => this.syncFade());
            this._resize.observe(body);
            this._mutate = new MutationObserver(() => this.syncFade());
            this._mutate.observe(body, { childList: true, subtree: true });
        },

        syncFade() {
            const body = this.$refs.body;
            if (!body) {
                this.showFade = false;
                return;
            }

            const overflow = body.scrollHeight - body.clientHeight > 1;
            const remaining = body.scrollHeight - body.clientHeight - body.scrollTop;
            this.showFade = overflow && remaining > FADE_END_MARGIN;
        },

        destroy() {
            this._resize?.disconnect();
            this._mutate?.disconnect();
        },
    }));
});
